import { Editable } from "../../../../base/components/advanced/input/editable"
import { Div } from "../../../../base/components/native/div"
import { moveCursorToEnd, selectAllContent } from "../../../../base/helpers/components"
import { replaceDigits } from "../../../../base/helpers/locales"
import { editableStyle, oldValueStyle, priceTdStyle } from "./price-td.style"
import { RateTd } from "./rate-td"

export const PriceToCadTd = (_v: string) => {

    let changed = false

    const base = RateTd()
    base.cssClass({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexDirection: 'row',
        width: '150px'
    })

    const oldValue = Div((_v))
    oldValue.cssClass(oldValueStyle)
    base.append(oldValue)

    let tempValue = _v
    const e = Editable({ text: _v })
    e.cssClass(editableStyle)

    e.on('focus', () => {
        selectAllContent(e.el);
    })
    e.on('enter', () => {
        e.blur()
    })
    e.on('escape', () => {
        e.setValue(tempValue)
        e.blur()
    })
    e.on('blur', () => {
        tempValue = e.getValue()
        if (tempValue !== _v) {
            console.log('in price change', tempValue, _v);

            changed = true
            oldValue.style({ display: 'block' })
        } else {
            changed = false
            oldValue.style({ display: 'none' })

        }
        base.emit('change', tempValue)
    })
    base.append(e)


    return Object.assign(base, {
        getValue() {
            let v = parseFloat(_v)

            // Grab the user-facing text from the editable element
            const userInput = e.getValue()

            // Convert Persian/Arabic digits to ASCII digits and remove non-numeric characters (except period)

            // Attempt to parse a float from cleaned input
            const parsedInput = parseFloat(userInput)

            // Decide what to return as the "value": 
            // if it's a valid number, use it as a string; otherwise use the raw user input
            const value = isNaN(parsedInput) ? userInput : parsedInput.toString()

            // Determine the "change" value by comparing original `v` with the parsed input
            let change = 0
            if (!isNaN(v) && isNaN(parsedInput)) {
                // Original is valid number, but new input is invalid => revert to original
                change = -v
            } else if (isNaN(v) && !isNaN(parsedInput)) {
                // Original was invalid, new input is valid => change is the new input
                change = parsedInput
            } else if (isNaN(v) || isNaN(parsedInput)) {
                // If either original or new input is invalid => no meaningful change
                change = 0
            } else {
                // Both original and new are valid => difference
                change = parsedInput - v
            }

            return { value, change }
        },
        changed: () => changed
    })
}

